module.exports = __webpack_public_path__ + "static/media/icon_head_brains.ee2ebf3f.svg";